import routesHome from "./routesHome";
import routesPost from "./routesPost";
// import routesProject from "./routesProject";
// import routesHomework from "./routesHomework";
import routesQuestion from "./routesQuestion";
// import routesStudent from "./routesStudent";
// import routesWallet from "./routesWallet";
import routesSetting from "./routesSetting";
import routesOther from "./routesOther";
import routesWelcome from "./routesWelcome";
// import routesChallenge from "./routesChallenge";
// import routesChallengeWork from "./routesChallengeWork";
import routesAbility from "./routesAbility";
import routesProgram from "./routesProgram";
// import routesSpot from "./routesSpot";
import routesContent from "./routesContent";
import routesServe from "./routesServe";
import routesAlone from "./routesAlone";
import TheLayout from "@/components/TheLayout.vue";
import TheLayoutOuter from "@/components/TheLayoutOuter.vue";

export default [
  {
    path: "/",
    component: TheLayout,
    redirect: { name: "Home" },
    meta: {
      breadcrumb: {
        title: "服务中心",
        replace: false
      }
    },
    children: [
      ...routesHome,
      ...routesPost,
      ...routesContent,
      ...routesQuestion,
      ...routesProgram,
      ...routesServe,
      // ...routesProject,
      // ...routesChallenge,
      // ...routesChallengeWork,
      // ...routesHomework,
      // ...routesSpot,
      // ...routesStudent,
      ...routesAbility,
      ...routesSetting,
      // ...routesWallet,
      ...routesOther
    ]
  },
  {
    path: "/welcome",
    component: TheLayoutOuter,
    redirect: { name: "WelcomeHomeSelf" },
    children: [...routesWelcome]
  },
  {
    path: "/alone",
    component: { render: h => h("router-view") },
    children: [...routesAlone]
  }
];
